<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="footer-contact">
        <div class="contact-icon-row">
          <img src="../../assets/common/footer/wechat.png" alt="phone" class="contact-icon" />
          <span class="contact-phone">{{ t('footer.info.phone') }}</span>
        </div>
        <div class="contact-info-list">
          <div v-html="t('footer.info.contact_person')"></div>
          <div v-html="t('footer.info.email')"></div> 
          <div v-html="t('footer.info.address')"></div>
        </div>
      </div>

      <div class="footer-menus">
        <div class="footer-menu">
          <div class="menu-title">{{ t('footer.products.title') }}</div>
          <router-link :to="{ path: '/product', query: { tab: 0 } }" class="menu-item">
            {{ t('footer.products.sport') }}
          </router-link>
          <router-link :to="{ path: '/product', query: { tab: 1 } }" class="menu-item">
            {{ t('footer.products.module') }}
          </router-link>
          <router-link :to="{ path: '/product', query: { tab: 2 } }" class="menu-item">
            {{ t('footer.products.screen') }}
          </router-link>
        </div>
        <div class="footer-menu">
          <div class="menu-title">{{ t('footer.odmService.title') }}</div>
          <div class="menu-item"><router-link to="/odm#odm_intro" class="menu-item">{{ t('footer.odmService.omd')
          }}</router-link></div>
          <div class="menu-item"><router-link to="/odm#odm_deliver" class="menu-item">{{
            t('footer.odmService.advantage') }}</router-link></div>
           <div class="menu-item"><router-link to="/odm#our_lab" class="menu-item">{{ t('footer.odmService.laboratory')
          }}</router-link></div>
        </div>
        <div class="footer-menu">
          <div class="menu-title">{{ t('footer.about.title') }}</div>
          <div class="menu-item"><router-link to="/about#company_intro" class="menu-item">{{ t('footer.about.company')
          }}</router-link></div>
          <div class="menu-item"><router-link to="/about#company_video" class="menu-item">{{ t('footer.about.vedio')
          }}</router-link></div>
          <div class="menu-item"><router-link to="/about#company_culture" class="menu-item">{{
            t('footer.about.culture') }}</router-link></div>
        </div>
        <div class="footer-menu">
          <div class="menu-title">{{ t('footer.contact.title') }}</div>
          <div class="menu-item"><router-link to="/contact#contact_info" class="menu-item">{{
            t('footer.contact.method') }}</router-link></div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-line"></div>
      <div class="footer-bottom-content">
        <div class="copyright-left">{{ t('footer.copyright') }}</div>
        <div class="copyright-right">{{ t('footer.icp') }}</div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
// 修改：解构 tm 方法
const { t} = useI18n();
</script>

<style scoped>
.footer {
  background: #363636;
  color: #ccc;
  font-size: 1rem;
  /* 需要完成适配 */
  padding-top: 50px;
  padding-bottom: 0;
}

.footer-main {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0 3vw;
  gap: 1vw;
  width: 80%;
}

.footer-contact {
  flex: 1.5;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 40px;
}

.contact-icon-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.contact-icon {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}

.contact-phone {
  font-size: 1.6rem;
  color: #d3d3d3;
  font-weight: bold;
}

.contact-info-list {
  color: #ccc;
  font-size: 1rem;
  line-height: 2.2;
}

.footer-menus {
  flex: 3;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.footer-menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.menu-title {
  color: #d3d3d3;
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 18px;
}

.menu-item {
  color: #d3d3d3;
  font-size: 1rem;
  line-height: 2.2;
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: none;
  /* 移除下划线 */
}

.menu-item:last-child {
  margin-bottom: 0;
}

.menu-item:hover {
  color: #fff;
}

.footer-bottom {
  margin-top: 100px;
  padding-bottom: 0;
}

.footer-bottom-line {
  width: 80%;
  height: 1px;
  background: #d3d3d3;
  opacity: 0.8;
  margin: 0 auto 18px;
}

.footer-bottom-content {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 30px 0;
  font-size: 1rem;
  color: #bdbdbd;
}

.copyright-left {
  text-align: left;
}

.copyright-right {
  text-align: right;
}

.nav-menu a.active {
  color: #ff7f1a;
  /* 橙色 */
  font-weight: bold;
}

.nav-menu,
.nav-menu ul,
.nav-menu a {
  pointer-events: auto;
  z-index: 1000;
}

::v-deep .address-container {
  display: flex;
  align-items: flex-start;
}
::v-deep .address-label {
  flex-shrink: 0; 
}
::v-deep .address-content {
  flex-grow: 1; 
  text-align: left; 
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .footer-main {
    width: 75%;
  }

  .footer-bottom-content {
    width: 75%;
    font-size: 1.1rem;
  }

  .footer-bottom-line {
    width: 75%;
  }

  .menu-title {
    font-size: 1.5rem;
  }

  .menu-item {
    font-size: 1.1rem;
     line-height: 2.6;
  }

  .contact-icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }

  .contact-phone {
    font-size: 1.5rem;
  }

  .contact-info-list {
    color: #ccc;
    font-size: 1.1rem;
    line-height: 2.7;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .footer-main {
    width: 80%;
  }

  .footer-bottom-content {
    width: 80%;
    font-size: 1rem;
  }

  .footer-bottom-line {
    width: 80%;
  }

  .menu-title {
    font-size: 1.4rem;
  }

  .menu-item {
    font-size: 1rem;
     line-height: 2.5;
  }

  .contact-icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }

  .contact-phone {
    font-size: 1.4rem;
  }

  .contact-info-list {
    color: #ccc;
    font-size: 1rem;
    line-height: 2.6;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .footer-main {
    width: 90%;
  }

  .footer-bottom-content {
    width: 90%;
    font-size: 0.9rem;
  }

  .footer-bottom-line {
    width: 90%;
  }

  .menu-title {
    font-size: 1.2rem;
  }

  .menu-item {
    font-size: 0.9rem;
    line-height: 2.4;
  }

  .contact-icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }

  .contact-phone {
    font-size: 1.2rem;
  }

  .contact-info-list {
    color: #ccc;
    font-size: 0.9rem;
    line-height: 2.5;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .footer-main {
    width: 90%;
  }

  .footer-bottom-content {
    width: 90%;
    font-size: 0.6rem;
  }

  .footer-bottom-line {
    width: 90%;
  }

  .menu-title {
    font-size: 0.8rem;
  }

  .menu-item {
    font-size: 0.6rem;
    line-height: 2.3;
  }

  .contact-icon {
    width: 26px;
    height: 26px;
    margin-right: 12px;
  }

  .contact-phone {
    font-size: 0.8rem;
  }

  .contact-info-list {
    color: #ccc;
    font-size: 0.6rem;
    line-height: 2.4;
  }

}
</style>